<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      {{ hasEmbedding().paperId }}

      @if (paper(); as paper) {
        <span class="header-action" (click)="viewDetails(paper)">{{ paper.title }}</span>
      } @else {
        {{ hasEmbedding().paperId }}
      }
    </mat-card-title>
    <mat-card-subtitle>Embedded: {{ hasEmbedding().hasEmbedding }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-actions align="end">
    <button mat-button (click)="viewEmbeddings()">View embeddings</button>
  </mat-card-actions>
</mat-card>
